export var valuesScormVersionEnum = ["V_1_2", "V_2004"];
/*

*/ 
//# sourceMappingURL=ScormVersionEnum.js.map